._FilterList_1p9fn_1 {
  position: relative;
}

._addFiltersButton_1p9fn_5 {
  display: flex;
  align-items: center;
  justify-content: center;
}